module.exports = __webpack_public_path__ + "static/Maunfacturing-Photo2-fb6961367469cb35fb42d2563f771829.png";